import { render, staticRenderFns } from "./AvoAlert.vue?vue&type=template&id=0428539a&"
import script from "./AvoAlert.vue?vue&type=script&lang=js&"
export * from "./AvoAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports